import { Phone, Instagram, Facebook, Youtube, Linkedin } from "lucide-react";
import { BRAND } from "../data/landing";

const XIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2H21l-6.52 7.46L22 22h-6.875l-4.51-5.79L5.4 22H2.64l6.96-7.96L2 2h7.04l4.06 5.34L18.244 2zm-2.41 18h1.92L7.27 4H5.27l10.564 16z" />
  </svg>
);

const TiktokIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V9.01a8.16 8.16 0 0 0 4.77 1.52V7.08a4.85 4.85 0 0 1-1.84-.39z" />
  </svg>
);

const ThreadsIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 192 192" fill="currentColor" aria-hidden="true">
    <path d="M141.537 88.988a66.667 66.667 0 0 0-2.518-1.143c-1.482-27.307-16.403-42.94-41.457-43.1h-.34c-14.986 0-27.449 6.4-35.13 18.053l13.793 9.46c5.74-8.705 14.747-10.562 21.348-10.562h.229c8.224.052 14.431 2.445 18.45 7.111 2.92 3.4 4.877 8.099 5.844 14.025-7.299-1.241-15.193-1.621-23.633-1.131-23.789 1.371-39.082 15.245-38.056 34.518.521 9.781 5.387 18.19 13.706 23.682 7.031 4.641 16.083 6.911 25.484 6.401 12.418-.681 22.163-5.421 28.957-14.092 5.16-6.58 8.421-15.107 9.866-25.762 5.94 3.585 10.345 8.301 12.776 13.974 4.131 9.652 4.373 25.515-8.566 38.448-11.341 11.34-24.97 16.247-45.564 16.397-22.84-.169-40.111-7.485-51.331-21.749-10.51-13.357-15.942-32.687-16.144-57.464.202-24.777 5.634-44.107 16.144-57.464 11.22-14.264 28.49-21.58 51.331-21.749 22.974.169 40.503 7.515 52.087 21.831 5.674 7.014 9.964 15.838 12.78 26.082l16.106-4.298c-3.401-12.598-8.798-23.464-16.179-32.595-14.789-18.32-36.461-27.713-64.467-27.913h-.045C45.523 5.967 23.823 15.703 9.196 34.305-4.13 51.291-11.119 75.063-11.404 105.105v.072c.285 30.045 7.274 53.817 20.6 70.802 14.627 18.602 36.327 28.338 64.504 28.531h.045c25.044-.174 42.692-6.722 57.224-21.225 19.018-18.99 18.43-42.787 12.166-57.428-4.475-10.443-13.058-18.831-24.598-24.869Zm-44.71 36.075c-10.395.585-21.297-4.074-21.835-14.181-.398-7.493 5.33-15.851 22.479-16.84a92.74 92.74 0 0 1 5.366-.154c5.864 0 11.357.585 16.352 1.704-1.871 23.391-12.851 28.886-22.362 29.471Z" />
  </svg>
);

const FaxIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M19 9V3H8v6" />
    <path d="M8 13H6a2 2 0 0 0-2 2v4h4" />
    <rect x="8" y="13" width="13" height="8" rx="1" />
    <path d="M12 17h.01M16 17h.01" />
  </svg>
);

const SOCIALS = [
  { Icon: ({ size }) => <Instagram size={size} strokeWidth={2} />, href: "instagram", label: "Instagram" },
  { Icon: ({ size }) => <ThreadsIcon size={size} />, href: "threads", label: "Threads" },
  { Icon: ({ size }) => <Facebook size={size} strokeWidth={2} />, href: "facebook", label: "Facebook" },
  { Icon: ({ size }) => <XIcon size={size} />, href: "x", label: "X" },
  { Icon: ({ size }) => <TiktokIcon size={size} />, href: "tiktok", label: "TikTok" },
  { Icon: ({ size }) => <Youtube size={size} strokeWidth={2} />, href: "youtube", label: "YouTube" },
];

export default function TopStrip() {
  return (
    <div
      className="w-full bg-[#0F0C73] text-white"
      style={{ fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif' }}
      data-testid="top-strip"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 sm:gap-6">
          <a
            href={BRAND.phoneHref}
            className="flex items-center gap-2 font-bold hover:opacity-80 transition-opacity"
            style={{ fontSize: "clamp(14px, 1.05vw, 16px)" }}
            data-testid="top-strip-phone"
          >
            <Phone size={20} strokeWidth={2.5} />
            <span>{BRAND.phone}</span>
          </a>
          <a
            href={BRAND.faxHref}
            className="flex items-center gap-2 font-bold hover:opacity-80 transition-opacity"
            style={{ fontSize: "clamp(14px, 1.05vw, 16px)" }}
            data-testid="top-strip-fax"
          >
            <FaxIcon size={20} />
            <span>Fax: {BRAND.fax}</span>
          </a>
        </div>

        <div className="flex items-center gap-2" data-testid="top-strip-socials">
          {SOCIALS.map(({ Icon, href, label }) => (
            <a
              key={label}
              href={BRAND.socials[href]}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="size-9 flex items-center justify-center rounded-full bg-white/15 hover:bg-white hover:text-[#1440E1] text-white transition-all duration-300 hover:scale-110 border border-white/30 shadow-[0_14px_32px_-8px_rgba(0,0,0,0.7),0_4px_10px_-2px_rgba(0,0,0,0.55),inset_0_1px_0_rgba(255,255,255,0.18)] hover:shadow-[0_22px_44px_-10px_rgba(255,255,255,0.65),0_0_0_4px_rgba(255,255,255,0.18),inset_0_1px_0_rgba(255,255,255,0.4)] backdrop-blur-md"
              data-testid={`social-${label.toLowerCase()}`}
            >
              <Icon size={15} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
